"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "How do I schedule a consultation?",
  answer: "Scheduling an appointment is simple and convenient. You can book directly through our online portal, or if you prefer a personal touch, our patient coordination team is available by phone to help you find a time that fits your schedule, including telehealth options."
}, {
  question: "What should I prepare for my first visit?",
  answer: "To ensure a smooth experience, please have your identification, insurance details, and any current medication lists ready. We recommend arriving 15 minutes before your scheduled time to complete your patient profile and discuss your health history with our specialists."
}, {
  question: "Do you offer remote health services?",
  answer: "Yes, we provide secure and comprehensive telehealth consultations for a wide range of conditions. This allows you to receive expert medical advice and follow-up care from the comfort of your home, ensuring continuity of care regardless of your location."
}, {
  question: "Which insurance plans do you accept?",
  answer: "We partner with a broad network of major insurance providers and international health plans. Our billing specialists are happy to verify your coverage details before your appointment to ensure you understand your benefits and any potential out-of-pocket costs."
}, {
  question: "How can I access my medical results?",
  answer: "Your health information is always at your fingertips. Through our secure patient portal, you can view diagnostic results, track your treatment progress, and communicate directly with your healthcare team at any time, day or night."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19155" id="frequently-asked-questions" ref={ref} className={cn("bg-background text-foreground relative w-full py-24 overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-accent/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-8 lg:col-start-3">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-4 tracking-tight">
                Frequently Asked Questions
              </h2>
              <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                Find answers to common questions about our medical treatments, patient care, and health insights. Our team is here to support your journey to wellness.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border px-2">
                  <AccordionTrigger className="text-[18px] font-sans font-bold text-foreground hover:text-accent hover:no-underline py-6 [&>svg]:text-accent [&>svg]:stroke-2 transition-colors duration-300">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="bg-muted/30 rounded-xl mb-4 px-6 py-6 text-[16px] leading-[1.6] text-foreground/90 font-sans backdrop-blur-sm border border-border">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>

            <div className="mt-12 text-center">
              <p className="text-muted-foreground mb-6">
                Still have questions? Our care team is ready to help.
              </p>
              <Button asChild variant="outline" className="border-accent text-accent hover:bg-accent hover:text-accent-foreground rounded-full px-8 transition-all duration-300">
                <Link to="/ContactPage">Contact Support</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}